import React from 'react';
import PropTypes from 'prop-types';
import Season from './components/Season';
import ProductTitle from './components/ProductTitle';
import BrandProductList from './styled/BrandProductList';
import ProductInfoCardWrapper from './styled/ProductInfoCardWrapper';
import PricesComponent from './components/PricesComponent';
import VerticalSpacer from '../VerticalSpacer/VerticalSpacer';

const ProductListProductInfo = props => {
  const {
    currencySymbol,
    showSale = false,
    bright,
    product: { brand, productName, currentPrice, originalPrice, reductionPercentage, season },
    width,
  } = props;

  return (
    <ProductInfoCardWrapper textAlign="center" fontSize="13px" width={width}>
      <BrandProductList data-cy="title-product-brand" fontSize="15px">
        {brand}
      </BrandProductList>
      <VerticalSpacer height="5px" />
      <ProductTitle productName={productName} bright={bright} />
      <VerticalSpacer height="5px" />
      <PricesComponent
        currencySymbol={currencySymbol}
        currentPrice={currentPrice}
        originalPrice={originalPrice}
        reductionPercentage={reductionPercentage}
        showSale={showSale}
      />
      <VerticalSpacer height="5px" />
      <Season season={season} />
    </ProductInfoCardWrapper>
  );
};

ProductListProductInfo.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  showSale: PropTypes.bool,
  product: PropTypes.shape({
    brand: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    currentPrice: PropTypes.string.isRequired,
    originalPrice: PropTypes.string,
    reductionPercentage: PropTypes.number,
    season: PropTypes.string.isRequired,
  }).isRequired,
  width: PropTypes.string.isRequired,
};

export default ProductListProductInfo;
